module.exports = "<template>\n    <reference-display if.bind=\"invoice\" reference.bind=\"invoice\"></reference-display>\n</template>\n";